jQuery(document).ready(function ($) {
    // Generalized Counter Animation using IntersectionObserver
    const counters = document.querySelectorAll('.counter-value');

    if (counters.length > 0) {
        const animateCounter = (counter) => {
            const target = parseInt(counter.getAttribute('data-target'));
            if (isNaN(target)) return;

            const duration = 2000; // 2 seconds
            const stepTime = 20; // Update every 20ms
            const steps = duration / stepTime;
            const increment = target / steps;

            let current = 0;
            const timer = setInterval(() => {
                current += increment;
                if (current >= target) {
                    current = target;
                    clearInterval(timer);
                }
                counter.textContent = Math.floor(current);
            }, stepTime);
        };

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const counter = entry.target;
                    // Check if already animated via class
                    if (!counter.classList.contains('animated')) {
                        counter.classList.add('animated');
                        animateCounter(counter);
                        observer.unobserve(counter); // Stop observing once started
                    }
                }
            });
        }, { threshold: 0.5 });

        counters.forEach(counter => {
            observer.observe(counter);
        });
    }

    // Legacy support for specific ID if needed (though class approach covers it if we update HTML)
    // The previous code targeted 'experience-counter' ID specifically. 
    // We should update the 'about_us_section' shortcode to use class 'counter-value' as well for consistency.
});
